// extracted by mini-css-extract-plugin
module.exports = {"counter":"MessagesCounter_counter__2FcQG"};